export const ENQUEUE = 'QUEUE_ACTIONS_ENQUEUE';
export const DEQUEUE = 'QUEUE_ACTIONS_DEQUEUE';
export const REMOVE = 'QUEUE_ACTIONS_REMOVE';
